var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-header-index-wide" },
    [
      _c("div", { staticStyle: { padding: "10px" } }, [
        _vm._v("\n    核酸情况\n  ")
      ]),
      _c(
        "a-row",
        {
          staticStyle: {
            background: "white",
            "margin-bottom": "30px",
            padding: "30px"
          }
        },
        [
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c(
                "a-card",
                {
                  staticStyle: {
                    height: "200px",
                    width: "300px",
                    "margin-left": "30px"
                  },
                  attrs: { title: "员工核酸结果" }
                },
                [
                  _c("div", [
                    _c("span", { staticStyle: { "font-size": "36px" } }, [
                      _vm._v(_vm._s(this.homeData.negative))
                    ]),
                    _c("span", [_vm._v("人 阴性")])
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "200px", width: "300px" },
                  attrs: { title: "员工核酸结果" }
                },
                [
                  _c("div", [
                    _c("span", { staticStyle: { "font-size": "36px" } }, [
                      _vm._v(_vm._s(this.homeData.positive))
                    ]),
                    _c("span", [_vm._v("人 阳性")])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { padding: "10px" } }, [
        _vm._v("\n    数据看板\n  ")
      ]),
      _c(
        "a-row",
        [
          _c(
            "a-col",
            {
              style: { marginBottom: "24px", paddingRight: "24px" },
              attrs: { span: 8 }
            },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: { title: "健康码态势" }
                },
                [
                  _c("pie-color", {
                    attrs: {
                      dataSource: _vm.healthCodeData,
                      midText: this.healthCodeTotal
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px", paddingRight: "24px" },
              attrs: { span: 8 }
            },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: { title: "核酸态势" }
                },
                [
                  _c("pie-color", {
                    attrs: {
                      dataSource: _vm.nucleicData,
                      colorChange: true,
                      midText: this.nucleicTotal
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-col",
            { style: { marginBottom: "24px" }, attrs: { span: 8 } },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "500px" },
                  attrs: { title: "超时预警" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "350px",
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center"
                      }
                    },
                    [
                      _c("div", [
                        _c("div", [
                          _vm._v("\n              接近72H人数\n            ")
                        ]),
                        _c("div", [
                          _c("span", { staticStyle: { "font-size": "36px" } }, [
                            _vm._v(_vm._s(this.homeData.between48And72))
                          ]),
                          _c("span", [_vm._v("人")])
                        ])
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { padding: "10px" } }, [
        _vm._v("\n    系统公告\n  ")
      ]),
      _c("a-table", {
        ref: "table",
        staticClass: "j-table-force-nowrap",
        staticStyle: { background: "white" },
        attrs: {
          size: "middle",
          scroll: { x: 1000 },
          bordered: "",
          rowKey: "id",
          columns: _vm.columns,
          dataSource: _vm.dataSource,
          pagination: false
        },
        scopedSlots: _vm._u([
          {
            key: "htmlSlot",
            fn: function(text) {
              return [
                text.includes("img")
                  ? _c("div", [_vm._v("图文内容")])
                  : _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$options.filters.setContent(text))
                      }
                    })
              ]
            }
          },
          {
            key: "action",
            fn: function(text, record) {
              return _c("span", {}, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleDetail(record)
                      }
                    }
                  },
                  [_vm._v("查看")]
                )
              ])
            }
          }
        ])
      }),
      _c(
        "j-modal",
        {
          staticClass: "detail-modal",
          attrs: {
            title: "查看详情",
            visible: _vm.detailModal.visible,
            top: 50,
            width: 600,
            switchFullscreen: "",
            footer: null
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.detailModal, "visible", $event)
            }
          }
        },
        [
          _vm.detailModal.url
            ? _c("iframe", {
                staticClass: "detail-iframe",
                attrs: { src: _vm.detailModal.url }
              })
            : _vm._e()
        ]
      ),
      _c("show-announcement", { ref: "ShowAnnouncement" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }